import React from 'react';
import colors from 'shared-components/theme/colors';
import { gilroyMedium } from 'shared-components/theme/fonts';
import Media from 'shared-components/theme/medias';
import styled from 'styled-components';
const Pills = ({ text, color, borderColor }) => {
    return (
        <Pill color={color} borderColor={borderColor}>
            {text}
        </Pill>
    );
};

export default Pills;

const Pill = styled.div`
    border-radius: 30px;
    color: ${(props) => props.color || colors.geoGreen[100]};
    border: 1px solid ${(props) => props.borderColor || colors.geoGreen[100]};
    padding: 16px 24px;
    font-family: ${gilroyMedium};
    font-size: 16px;
    font-weight: 500;

    ${Media('large')} {
        font-size: 0.952vw;
        padding: 0.952vw 1.428vw;
        border-radius: 1.8vw;
    }
    ${Media('mobile')} {
        font-size: 14px;
        padding: 12px;
    }
`;
